import React, { useEffect } from "react";
import BannerIntern from "./Body/BannerIntern";
import { validationLan } from "../../../ValidationLan/ValidationLan";

const Intern = () => {
  let isArabic = localStorage.getItem("lan") === "AR";
  useEffect(() => {
    validationLan();
  }, [isArabic]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <BannerIntern />;
};

export default Intern;
